'use strict';

let routes = function ($stateProvider, baseState) {

    $stateProvider

        .state('' + baseState + '.financial-events-overview', {
            url: "/overview",
            template: require("./inspect.financial-events-overview.html"),
            data: {pageTitle: 'Inspect'}
        })

        .state('' + baseState + '.financial-events', {
            abstract: true,
            url: "/financial-events?"
            + "cf_ClerkFinancialEvent_page?"
            + "&cf_ClerkFinancialEvent_order?"
            + "&cf_ClerkFinancialEvent_from_date?"
            + "&cf_ClerkFinancialEvent_to_date?"
            + "&cf_ClerkFinancialEvent_from_clerk_account_id?"
            + "&cf_ClerkFinancialEvent_to_clerk_account_id?"
            + "&cf_ClerkFinancialEvent_from_or_to_clerk_account_id?"
            + "&cf_ClerkFinancialEvent_FromOrToClerkAccount_clerk_tax_entity_id?"
            + "&cf_ClerkFinancialEvent_max_abs_amount?"
            + "&cf_ClerkFinancialEvent_min_abs_amount?"
            + "&cf_ClerkFinancialEvent_receiving_party_clerk_tax_entity_id?"
            + "&cf_ClerkFinancialEvent_sending_party_clerk_tax_entity_id?"
            + "&cf_ClerkFinancialEvent_receiving_or_sending_party_clerk_tax_entity_id?"
            + "&cf_ClerkFinancialEvent_ledger_relevant_for_clerk_tax_entity_id?"
            + "&cf_ClerkFinancialEvent_receiving_party_clerk_ledger_entry_type_id?"
            + "&cf_ClerkFinancialEvent_sending_party_clerk_ledger_entry_type_id?"
            + "&cf_ClerkFinancialEvent_receiving_or_sending_party_clerk_ledger_entry_type_id?"
            + "&cf_ClerkFinancialEvent_pays_clerk_invoice_id?"
            + "&cf_ClerkFinancialEvent_pays_clerk_trip_id?"
            + "&cf_ClerkFinancialEvent_part_of_clerk_travel_claim_id?"
            + "&cf_ClerkFinancialEvent_split_parent_clerk_transaction_row_id?"
            + "&cf_ClerkFinancialEvent_split_family_of_clerk_transaction_row_id?"
            + "&cf_ClerkFinancialEvent_personal_empire_perspective_clerk_in_out_neither_category_id?"
            + "&cf_ClerkFinancialEvent_sending_or_receiving_party_perspective_clerk_in_out_neither_category_id?"
            + "&cf_ClerkFinancialEvent_supporting_documents_not_deemed_good_enough?"

            + "&cf_ClerkFinancialEvent_ClerkInvoice_sent_from_clerk_tax_entity_id?"
            + "&cf_ClerkFinancialEvent_ClerkInvoice_sent_to_clerk_tax_entity_id?"
            + "&cf_ClerkFinancialEvent_ClerkInvoice_max_abs_amount?"
            + "&cf_ClerkFinancialEvent_ClerkInvoice_min_abs_amount?"
            + "&cf_ClerkFinancialEvent_ClerkInvoiceRow_page?"
            + "&cf_ClerkFinancialEvent_ClerkInvoiceRow_max_abs_amount?"
            + "&cf_ClerkFinancialEvent_ClerkInvoiceRow_min_abs_amount?"

            + "&cf_ClerkFinancialEvent_ClerkTransactionRow_order?"
            + "&cf_ClerkFinancialEvent_ClerkTransactionRow_from_date?"
            + "&cf_ClerkFinancialEvent_ClerkTransactionRow_to_date?"
            + "&cf_ClerkFinancialEvent_ClerkTransactionRow_from_clerk_account_id?"
            + "&cf_ClerkFinancialEvent_ClerkTransactionRow_to_clerk_account_id?"
            + "&cf_ClerkFinancialEvent_ClerkTransactionRow_from_or_to_clerk_account_id?"
            + "&cf_ClerkFinancialEvent_ClerkTransactionRow_FromOrToClerkAccount_clerk_tax_entity_id?"
            + "&cf_ClerkFinancialEvent_ClerkTransactionRow_max_abs_amount?"
            + "&cf_ClerkFinancialEvent_ClerkTransactionRow_min_abs_amount?"
            + "&cf_ClerkFinancialEvent_ClerkTransactionRow_receiving_party_clerk_tax_entity_id?"
            + "&cf_ClerkFinancialEvent_ClerkTransactionRow_sending_party_clerk_tax_entity_id?"
            + "&cf_ClerkFinancialEvent_ClerkTransactionRow_receiving_or_sending_party_clerk_tax_entity_id?"
            + "&cf_ClerkFinancialEvent_ClerkTransactionRow_ledger_relevant_for_clerk_tax_entity_id?"
            + "&cf_ClerkFinancialEvent_ClerkTransactionRow_receiving_party_clerk_ledger_entry_type_id?"
            + "&cf_ClerkFinancialEvent_ClerkTransactionRow_sending_party_clerk_ledger_entry_type_id?"
            + "&cf_ClerkFinancialEvent_ClerkTransactionRow_receiving_or_sending_party_clerk_ledger_entry_type_id?"
            + "&cf_ClerkFinancialEvent_ClerkTransactionRow_pays_clerk_invoice_id?"
            + "&cf_ClerkFinancialEvent_ClerkTransactionRow_pays_clerk_trip_id?"
            + "&cf_ClerkFinancialEvent_ClerkTransactionRow_part_of_clerk_travel_claim_id?"
            /*
            Not triggerable by state params, only route params
            + "&cf_ClerkFinancialEvent_ClerkTransactionRow_hide_split_parents?"
            + "&cf_ClerkFinancialEvent_ClerkTransactionRow_hide_split_children?"
            */
            + "&cf_ClerkFinancialEvent_ClerkTransactionRow_split_parent_clerk_transaction_row_id?"
            + "&cf_ClerkFinancialEvent_ClerkTransactionRow_split_family_of_clerk_transaction_row_id?"
            + "&cf_ClerkFinancialEvent_ClerkTransactionRow_personal_empire_perspective_clerk_in_out_neither_category_id?"
            + "&cf_ClerkFinancialEvent_ClerkTransactionRow_sending_or_receiving_party_perspective_clerk_in_out_neither_category_id?"
            + "&cf_ClerkFinancialEvent_ClerkTransactionRow_supporting_documents_not_deemed_good_enough?"
            ,
            params: {
                workflowStep: {dynamic: true},
                cf_ClerkFinancialEvent_page: {value: '1', dynamic: true},
                cf_ClerkFinancialEvent_order: {value: null, dynamic: true},
                cf_ClerkFinancialEvent_from_date: {value: null, dynamic: true},
                cf_ClerkFinancialEvent_to_date: {value: null, dynamic: true},
                cf_ClerkFinancialEvent_from_clerk_account_id: {value: null, dynamic: true},
                cf_ClerkFinancialEvent_to_clerk_account_id: {value: null, dynamic: true},
                cf_ClerkFinancialEvent_from_or_to_clerk_account_id: {value: null, dynamic: true},
                cf_ClerkFinancialEvent_FromOrToClerkAccount_clerk_tax_entity_id: {value: null, dynamic: true},
                cf_ClerkFinancialEvent_max_abs_amount: {value: null, dynamic: true},
                cf_ClerkFinancialEvent_min_abs_amount: {value: null, dynamic: true},
                cf_ClerkFinancialEvent_receiving_party_clerk_tax_entity_id: {value: null, dynamic: true},
                cf_ClerkFinancialEvent_sending_party_clerk_tax_entity_id: {value: null, dynamic: true},
                cf_ClerkFinancialEvent_receiving_or_sending_party_clerk_tax_entity_id: {value: null, dynamic: true},
                cf_ClerkFinancialEvent_ledger_relevant_for_clerk_tax_entity_id: {value: null, dynamic: true},
                cf_ClerkFinancialEvent_receiving_party_clerk_ledger_entry_type_id: {value: null, dynamic: true},
                cf_ClerkFinancialEvent_sending_party_clerk_ledger_entry_type_id: {value: null, dynamic: true},
                cf_ClerkFinancialEvent_receiving_or_sending_party_clerk_ledger_entry_type_id: {
                    value: null,
                    dynamic: true
                },
                cf_ClerkFinancialEvent_pays_clerk_invoice_id: {value: null, dynamic: true},
                cf_ClerkFinancialEvent_pays_clerk_trip_id: {value: null, dynamic: true},
                cf_ClerkFinancialEvent_part_of_clerk_travel_claim_id: {value: null, dynamic: true},
                cf_ClerkFinancialEvent_split_parent_clerk_transaction_row_id: {value: null, dynamic: true},
                cf_ClerkFinancialEvent_split_family_of_clerk_transaction_row_id: {value: null, dynamic: true},
                cf_ClerkFinancialEvent_personal_empire_perspective_clerk_in_out_neither_category_id: {
                    value: null,
                    dynamic: true
                },
                cf_ClerkFinancialEvent_sending_or_receiving_party_perspective_clerk_in_out_neither_category_id: {
                    value: null,
                    dynamic: true
                },
                cf_ClerkFinancialEvent_supporting_documents_not_deemed_good_enough: {value: null, dynamic: true},

                cf_ClerkFinancialEvent_ClerkInvoice_page: {value: '1', dynamic: true},
                cf_ClerkFinancialEvent_ClerkInvoice_sent_from_clerk_tax_entity_id: {value: '', dynamic: true},
                cf_ClerkFinancialEvent_ClerkInvoice_sent_to_clerk_tax_entity_id: {value: '', dynamic: true},
                cf_ClerkFinancialEvent_ClerkInvoice_max_abs_amount: {value: '', dynamic: true},
                cf_ClerkFinancialEvent_ClerkInvoice_min_abs_amount: {value: '', dynamic: true},
                cf_ClerkFinancialEvent_ClerkInvoiceRow_page: {value: '1', dynamic: true},
                cf_ClerkFinancialEvent_ClerkInvoiceRow_max_abs_amount: {value: '', dynamic: true},
                cf_ClerkFinancialEvent_ClerkInvoiceRow_min_abs_amount: {value: '', dynamic: true},

                cf_ClerkFinancialEvent_ClerkTransactionRow_page: {value: '1', dynamic: true},
                cf_ClerkFinancialEvent_ClerkTransactionRow_order: {value: null, dynamic: true},
                cf_ClerkFinancialEvent_ClerkTransactionRow_from_date: {value: null, dynamic: true},
                cf_ClerkFinancialEvent_ClerkTransactionRow_to_date: {value: null, dynamic: true},
                cf_ClerkFinancialEvent_ClerkTransactionRow_from_clerk_account_id: {value: null, dynamic: true},
                cf_ClerkFinancialEvent_ClerkTransactionRow_to_clerk_account_id: {value: null, dynamic: true},
                cf_ClerkFinancialEvent_ClerkTransactionRow_from_or_to_clerk_account_id: {value: null, dynamic: true},
                cf_ClerkFinancialEvent_ClerkTransactionRow_FromOrToClerkAccount_clerk_tax_entity_id: {value: null, dynamic: true},
                cf_ClerkFinancialEvent_ClerkTransactionRow_max_abs_amount: {value: null, dynamic: true},
                cf_ClerkFinancialEvent_ClerkTransactionRow_min_abs_amount: {value: null, dynamic: true},
                cf_ClerkFinancialEvent_ClerkTransactionRow_receiving_party_clerk_tax_entity_id: {value: null, dynamic: true},
                cf_ClerkFinancialEvent_ClerkTransactionRow_sending_party_clerk_tax_entity_id: {value: null, dynamic: true},
                cf_ClerkFinancialEvent_ClerkTransactionRow_receiving_or_sending_party_clerk_tax_entity_id: {value: null, dynamic: true},
                cf_ClerkFinancialEvent_ClerkTransactionRow_ledger_relevant_for_clerk_tax_entity_id: {value: null, dynamic: true},
                cf_ClerkFinancialEvent_ClerkTransactionRow_receiving_party_clerk_ledger_entry_type_id: {value: null, dynamic: true},
                cf_ClerkFinancialEvent_ClerkTransactionRow_sending_party_clerk_ledger_entry_type_id: {value: null, dynamic: true},
                cf_ClerkFinancialEvent_ClerkTransactionRow_receiving_or_sending_party_clerk_ledger_entry_type_id: {
                    value: null,
                    dynamic: true
                },
                cf_ClerkFinancialEvent_ClerkTransactionRow_pays_clerk_invoice_id: {value: null, dynamic: true},
                cf_ClerkFinancialEvent_ClerkTransactionRow_pays_clerk_trip_id: {value: null, dynamic: true},
                cf_ClerkFinancialEvent_ClerkTransactionRow_part_of_clerk_travel_claim_id: {value: null, dynamic: true},
                /*
                Not triggerable by state params, only route params
                cf_ClerkFinancialEvent_ClerkTransactionRow_hide_split_parents: {value: null, dynamic: true},
                cf_ClerkFinancialEvent_ClerkTransactionRow_hide_split_children: {value: null, dynamic: true},
                */
                cf_ClerkFinancialEvent_ClerkTransactionRow_split_parent_clerk_transaction_row_id: {value: null, dynamic: true},
                cf_ClerkFinancialEvent_ClerkTransactionRow_split_family_of_clerk_transaction_row_id: {value: null, dynamic: true},
                cf_ClerkFinancialEvent_ClerkTransactionRow_personal_empire_perspective_clerk_in_out_neither_category_id: {
                    value: null,
                    dynamic: true
                },
                cf_ClerkFinancialEvent_ClerkTransactionRow_sending_or_receiving_party_perspective_clerk_in_out_neither_category_id: {
                    value: null,
                    dynamic: true
                },
                cf_ClerkFinancialEvent_ClerkTransactionRow_supporting_documents_not_deemed_good_enough: {value: null, dynamic: true},
            },
            template: require("./inspect.financial-events.html"),
        })

        .state('' + baseState + '.financial-events.curate', {
            url: "/curate",
            template: require("./inspect.financial-events.curate.html"),
            resolve: {
                setRouteBasedVisibilitySettingsLevel0: /*@ngInject*/ function (routeBasedVisibilitySettings, $stateParams) {
                    routeBasedVisibilitySettings.ClerkFinancialEvent_columns_by_step = 'simple';
                },
            },
            data: {pageTitle: 'Inspect'}
        })

        .state('' + baseState + '.financial-events.add-images-and-or-pdfs', {
            url: "/add-images-and-or-pdfs",
            template: require("./inspect.financial-events.add-images-and-or-pdfs.html"),
            resolve: {
                setRouteBasedVisibilitySettingsLevel0: /*@ngInject*/ function (routeBasedVisibilitySettings, $stateParams) {
                    routeBasedVisibilitySettings.ClerkFinancialEvent_columns_by_step = 'add-images-and-or-pdfs';
                },
            },
            data: {pageTitle: 'Inspect'}
        })

        .state('' + baseState + '.financial-events.tax-entities', {
            url: "/tax-entities",
            template: require("./inspect.financial-events.tax-entities.html"),
            data: {pageTitle: 'Inspect'}
        })

        .state('' + baseState + '.financial-events.accounts', {
            url: "/accounts",
            template: require("./inspect.financial-events.accounts.html"),
            data: {pageTitle: 'Inspect'}
        })

        .state('' + baseState + '.financial-events.account-balances', {
            url: "/account-balances",
            template: require("./inspect.financial-events.account-balances.html"),
            data: {pageTitle: 'Inspect'}
        })

    ;

    $stateProvider

    // Curate-steps
        .state('' + baseState + '.financial-events.curate.by-curate-step', {
            url: "/:curateStep/:activeClerkFinancialEventId?"
            + "",
            params: {
                curateStep: {dynamic: false},
                activeClerkFinancialEventId: {value: null, dynamic: false}
            },
            resolve: {
                setRouteBasedVisibilitySettingsLevel0: /*@ngInject*/ function (routeBasedVisibilitySettings, $stateParams) {
                    routeBasedVisibilitySettings.ClerkFinancialEvent_columns_by_step = 'financial-events.financial-events.' + $stateParams.curateStep;
                },
                setRouteBasedContentFiltersLevel1: /*@ngInject*/ function (routeBasedContentFilters, setRouteBasedContentFiltersLevel0, $stateParams) {
                    routeBasedContentFilters.ClerkLedgerEntry_stemming_from_clerk_financial_event_id = $stateParams.activeClerkFinancialEventId;
                    routeBasedContentFilters.ClerkLedgerEntryRow_ClerkLedgerEntry_stemming_from_clerk_financial_event_id = $stateParams.activeClerkFinancialEventId;
                },
                currentClerkFinancialEvent: /*@ngInject*/ function (dataEnvironmentParam, $stateParams, clerkFinancialEvent) {
                    var clerkFinancialEventId = $stateParams.activeClerkFinancialEventId === 'all' ? null : $stateParams.activeClerkFinancialEventId;
                    if (clerkFinancialEventId) {
                        clerkFinancialEvent.$activate();
                        return clerkFinancialEvent.load($stateParams.activeClerkFinancialEventId);
                    } else {
                        return null;
                    }
                },
            }
        });

    /*
     .state('' + baseState + '.optionally-by-clerk-ledger-deliverable.inspect.financial-events.tax-regions', {
     url: "/tax-regions",
     onEnter: function () {
     },
     data: {pageTitle: 'Inspect'}
     })
     */

};

let loadRoutesLazily = function ($stateProvider, baseState) {

    let lazyStateProvider = {
        states: [],
        state: function (name, stateConfig) {
            let state = angular.merge({name: name}, stateConfig);
            this.states.push(state);
            return this;
        }
    };
    routes(lazyStateProvider, baseState);
    $stateProvider.state(baseState + '.financial-events.**', {
        url: "/financial-events",
        lazyLoad: function ($transition$, ParentService) {
            return lazyStateProvider;
        },
    });

};

export default {
    routes: routes,
    loadRoutesLazily: loadRoutesLazily,
};



// WEBPACK FOOTER //
// .-dna/app/subsections/financial-events/financial-events.js